import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/AdminDashboard';
import StaffDashboard from './pages/StaffDashboard';
import CustomerUI from './pages/CustomerUI';
import './App.css';

function App() {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Yükleniyor...</div>;
  }

  return (
    <CartProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          {/* Ana sayfa - Müşteri arayüzü */}
          <Route path="/*" element={<CustomerUI />} />
          
          {/* Admin giriş sayfası */}
          <Route path="/login" element={
            user?.role === 'admin' ? <Navigate to="/admin/dashboard" /> : <LoginPage />
          } />
          
          {/* Admin paneli - giriş yapmamışsa login'e yönlendir */}
          <Route 
            path="/admin/*" 
            element={user?.role === 'admin' ? <AdminDashboard /> : <Navigate to="/login" />} 
          />
          
          {/* Staff paneli */}
          <Route 
            path="/staff/*" 
            element={user?.role === 'staff' ? <StaffDashboard /> : <Navigate to="/login" />} 
          />
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
